import { createRouter as createVueRouter, createWebHistory } from "vue-router";
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from "@/auth/utils";
import configHelper from "@/libs/configHelper";

const routes = [
  // Unauthorized
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: () => import("@/views/Auth403.vue"),
    meta: {
      pageTitle: "403 Unauthorized",
    },
  },
  // Unauthorized End
  // Home
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: {
      pageTitle: "navigations.home",
      layout: "full",
    },
  },
  // Home End
  // Logout
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/Logout.vue"),
    meta: {
      pageTitle: "navigations.logout",
      layout: "full",
    },
  },
  // Logout End
  // Login
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      pageTitle: "navigations.login",
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  // Login End
  // Forgot Password
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/ForgotPassword.vue"),
    meta: {
      pageTitle: "navigations.forgotPassword",
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  // Forgot Password End
  // CustomResources
  {
    path: "/ulohy",
    name: "customResources",
    component: () => import("@/views/Admin/CustomResources/list.vue"),
    meta: {
      pageTitle: "navigations.customResources",
      breadcrumb: [
        {
          text: "navigations.customResources",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/ulohy/:id/edit",
    name: "EditCustomResource",
    component: () => import("@/views/Admin/CustomResources/edit.vue"),
    meta: {
      pageTitle: "customResource.update",
      breadcrumb: [
        {
          text: "customResource.update",
          active: true,
        },
      ],
      actionType: "UPDATE",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/pridat-ulohu",
    name: "AddNewCustomResource",
    component: () => import("@/views/Admin/CustomResources/add.vue"),
    meta: {
      pageTitle: "customResource.new",
      breadcrumb: [
        {
          text: "customResource.new",
          active: true,
        },
      ],
      actionType: "CREATE",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/strom-kategorii-uloh",
    name: "CustomResourceCategoryTree",
    component: () => import("@/views/Admin/Categories/categoryTree.vue"),
    meta: {
      pageTitle: "customResource.categoryTree",
      breadcrumb: [
        {
          text: "customResource.categoryTree",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/testy",
    name: "tests",
    component: () => import("@/views/Admin/Tests/list.vue"),
    meta: {
      pageTitle: "navigations.tests",
      breadcrumb: [
        {
          text: "navigations.tests",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/testy/:id/edit",
    name: "EditTest",
    component: () => import("@/views/Admin/Tests/edit.vue"),
    meta: {
      pageTitle: "test.update",
      breadcrumb: [
        {
          text: "test.update",
          active: true,
        },
      ],
      actionType: "UPDATE",
      permission: "CUSTOM_RESOURCES",
    },
  },
  {
    path: "/pridat-test",
    name: "AddNewTest",
    component: () => import("@/views/Admin/Tests/add.vue"),
    meta: {
      pageTitle: "test.new",
      breadcrumb: [
        {
          text: "test.new",
          active: true,
        },
      ],
      actionType: "CREATE",
      permission: "CUSTOM_RESOURCES",
    },
  },
  // CustomResources End
  // CustomResources Categories
  {
    path: "/kategorie-uloh",
    name: "customResourceCategories",
    component: () => import("@/views/Admin/Categories/list.vue"),
    meta: {
      pageTitle: "navigations.customResourceCategories",
      breadcrumb: [
        {
          text: "navigations.customResourceCategories",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "CUSTOM_RESOURCE_CATEGORIES",
    },
  },
  {
    path: "/kategorie-uloh/:id/edit",
    name: "EditCustomResourceCategory",
    component: () => import("@/views/Admin/Categories/edit.vue"),
    meta: {
      pageTitle: "customResourceCategory.update",
      breadcrumb: [
        {
          text: "customResourceCategory.update",
          active: true,
        },
      ],
      actionType: "UPDATE",
      permission: "CUSTOM_RESOURCE_CATEGORIES",
    },
  },
  {
    path: "/pridat-kategoriu-uloh",
    name: "AddNewCustomResourceCategory",
    component: () => import("@/views/Admin/Categories/add.vue"),
    meta: {
      pageTitle: "customResourceCategory.new",
      breadcrumb: [
        {
          text: "customResourceCategory.new",
          active: true,
        },
      ],
      actionType: "CREATE",
      permission: "CUSTOM_RESOURCE_CATEGORIES",
    },
  },
  // CustomResources Categories End
  // Variables
  {
    path: "/variables",
    name: "variables",
    component: () => import("@/views/Admin/Variables/list.vue"),
    meta: {
      pageTitle: "navigations.variables",
      breadcrumb: [
        {
          text: "navigations.variables",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "ENVIRONMENT_VARIABLES",
    },
  },
  // Variables End
  // Blocks
  {
    path: "/blocks",
    name: "blocks",
    component: () => import("@/views/Admin/Blocks/list.vue"),
    meta: {
      pageTitle: "navigations.blocks",
      breadcrumb: [
        {
          text: "navigations.blocks",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "JSON_BLOCKS",
    },
  },
  {
    path: "/add-block",
    name: "AddNewBlock",
    component: () => import("@/views/Admin/Blocks/add.vue"),
    meta: {
      pageTitle: "block.new",
      breadcrumb: [
        {
          text: "block.new",
          active: true,
        },
      ],
      actionType: "CREATE",
      permission: "JSON_BLOCKS",
    },
  },
  {
    path: "/blocks/:id/edit",
    name: "EditBlock",
    component: () => import("@/views/Admin/Blocks/edit.vue"),
    meta: {
      pageTitle: "block.update",
      breadcrumb: [
        {
          text: "block.update",
          active: true,
        },
      ],
      actionType: "UPDATE",
      permission: "JSON_BLOCKS",
    },
  },
  // Blocks End
  // User profile
  {
    path: "/profile",
    name: "EditProfile",
    component: () => import("@/views/Admin/UserProfile/edit.vue"),
    meta: {
      pageTitle: "user.update",
      breadcrumb: [
        {
          text: "user.update",
          active: true,
        },
      ],
    },
  },
  // User profile end
  // Translations
  {
    path: "/translations",
    name: "Translations",
    component: () => import("@/views/Admin/Translations/edit.vue"),
    meta: {
      pageTitle: "navigations.translations",
      breadcrumb: [
        {
          text: "navigations.translations",
          active: true,
        },
      ],
      actionType: "LIST",
      permission: "WEB_TRANSLATIONS",
    },
  },
  // Translations end
];

// eslint-disable-next-line no-unused-vars
export const createRouter = (app) => {
  const router = createVueRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to, _, next) => {
    let isLoggedIn = isUserLoggedIn();
    const userData = getUserData();

    if (to.name === "logout") {
      return next();
    }

    if (userData && !["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_EMPLOYEE"].includes(userData.role)) {
      return next({ name: "logout" });
    }

    if (to.name === "unauthorized") {
      return next();
    }

    // Redirect to login if not logged in
    if (!isLoggedIn && to.name !== "login" && to.name !== "forgot-password") {
      return next({ name: "login" });
    }

    // Redirect if logged in
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
      const userData = getUserData();
      next(getHomeRouteForLoggedInUser(userData ? userData : null, router));
    }

    // Router guards
    if (isLoggedIn) {
      let unauthorized = true;
      if (!["ROLE_SUPER_ADMIN", "ROLE_ADMIN"].includes(userData.role) && to.meta.permission) {
        const permissions = userData.permissionRole?.permissions;
        if (permissions && to.meta.permission && to.meta.actionType) {
          const concretePermition = permissions.find((p) => p.name === to.meta.permission);
          if (concretePermition[to.meta.actionType]) {
            unauthorized = false;
          }
        }
        if (unauthorized) {
          next("/unauthorized");
        }
      }
    }

    // Language guards
    const enabledLanguages = configHelper.getShopLanguages();
    if (to.query.translation && !enabledLanguages.includes(to.query.translation)) {
      const query = Object.assign({}, to.query);
      delete query.translation;
      to.query = query;
      next(to);
    }

    return next();
  });

  // ? For splash screen
  // Remove afterEach hook if you are not using splash screen
  router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
      appLoading.style.display = "none";
    }
  });

  return router;
};
